export const navbar = {
  width: 786,
  items: [
    {
      name: "All Studies",
      menuItem: [],
      permName: "READ_STUDY",
      route: "/",
    },
    {
      name: "Prospects",
      menuItem: [
        {
          name: "Lookup Prospect",
          route: "/prospects/lookup",
          permName: "READ_PROSPECT",
        },
      ],
    },
    {
      name: "Reports",
      menuItem: [
        {
          name: "Portfolio Reports",
          route: "/portfolio/reports",
          permName: "VIEW_PARTICIPANT_BREAKDOWN",
        },
        {
          name: "Study Reports",
          route: "/study/reports",
          permName: "READ_STUDY_SUMMARY",
        },
      ],
    },
    {
      name: "Study Recruitment",
      menuItem: [],
      permName: "READ_STUDY_LIMITED",
      route: "/study-recruitment",
    },
    {
      name: "Activity",
      menuItem: [],
      adminOnly: true,
      route: "/activity-log",
    },
  ],
};
